<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        {{$ml.get('copyright')}}
        &copy; {{new Date().getFullYear()}},
        <a href="https://nimmshop.at" target="_blank">NimmNet</a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data(){
      return {}
    }
  }
</script>
<style>
</style>
